function HoverStart(event){
  if (screen.width<768){
    return
  }
    let allelem = document.querySelectorAll('.magnifying-area')
    for (let index = 0; index < allelem.length; index++) {
        const element = allelem[index];
        if (element!=event.target){
            element.style.display = "none"
        }
    }

    let magnifying_area = event.target
    let magnifying_img = magnifying_area.children[0]
    clientX = event.offsetX
    clientY = event.offsetY

    mWidth = magnifying_img.offsetWidth
    mHeight = magnifying_img.offsetHeight

    clientX = (clientX / mWidth * 100)
    clientY = (clientY / mHeight * 100)
    
    magnifying_img.style.translate = '-'+ clientX +'% -'+clientY+'%'
    magnifying_img.style.scale = "2"
}

function HoverEnd(event){
  if (screen.width<768){
    return
  }
    let allelem = document.querySelectorAll('.magnifying-area')
    for (let index = 0; index < allelem.length; index++) {
        const element = allelem[index];
        if (element!=event.target){
            element.style.display = "block"
        }
    }
    event.target.children[0].style.translate = '-50% -50%'
    event.target.children[0].style.scale = "1"
     
}